import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream px-4 py-14" data-id="element-107">
      <div className="mx-auto max-w-2xl rounded-3xl border border-teal/25 bg-white p-7 text-center shadow-card sm:p-9" data-id="element-108">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-teal/10" data-id="element-109">
          <ShieldCheckIcon className="h-8 w-8 text-teal" data-id="element-110" />
        </div>
        <h2 className="font-display text-2xl font-black text-navy sm:text-3xl" data-id="element-111">
          Garantía 7 días — sin preguntas
        </h2>
        <div className="mt-4 space-y-2 text-[15px] leading-relaxed text-navy/70" data-id="element-112">
          <p data-id="element-113">Abres los tomos. Los usas en el aula.</p>
          <p className="font-semibold text-navy" data-id="element-114">
            Si el lunes no entras diferente, te devolvemos el 100%.
          </p>
          <p className="text-sm" data-id="element-115">Sin formularios, sin drama.</p>
        </div>
        <p className="mt-5 inline-block rounded-full bg-teal/10 px-4 py-1.5 text-sm font-bold text-teal" data-id="element-116">
          Tasa de devoluciones: menos del 1%
        </p>
      </div>
    </section>;
}